import { FC, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Button, useColorMode } from '@chakra-ui/react';

type ForumTutorialButtonProps = {
  onOpen: () => void,
}

export const ForumTutorialButton: FC<ForumTutorialButtonProps> = ({
  onOpen,
}) => {
  const { colorMode } = useColorMode();

  const darkMode = useMemo(() => colorMode === 'dark', [colorMode]);
  const bgColor = useMemo(() => (darkMode ? '#504712' : '#F3E394'), [darkMode]);
  const color = useMemo(() => (darkMode ? '#D9E3FD' : '#051B3C'), [darkMode]);
  const iconColor = useMemo(() => (darkMode ? '#AFC7FB' : '#2E74DC'), [darkMode]);

  return (
    <Button
      color={color}
      bgColor={bgColor}
      rightIcon={<FontAwesomeIcon icon={faChevronRight} color={iconColor} />}
      onClick={onOpen}
      borderRadius="50px"
      isRound
      size="md"
    >
      Entenda como funciona o fórum da Aristo
    </Button>
  );
};
